import React from "react";
import news1 from "../../asset/news 1 (1).png";
import news2 from "../../asset/news 1 (2).png";
// import { Navigation, Autoplay, FreeMode, Pagination } from "swiper/modules";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css/free-mode";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/autoplay";
import { NavLink } from "react-router-dom";
import { useGetLatestPublishedBlogsQuery } from "../../Redux/getApi";
import { BlogCardLoader } from "../../Pages/Blog/Blog";

const NewsSlider = () => {
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };
  const { data, isLoading, isFetching, error } =
    useGetLatestPublishedBlogsQuery();
  return (
    <>
      {data?.blogs?.length > 0 && (
        <div className="py-10 xl:px-[5%] lg:px-[3%] md:px-[2%] px-[4%] gap-8 flex flex-col  items-center justify-center">
          <div className=" flex flex-col">
            <span className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[1.8rem] font-bold text-center">
              Blogs
            </span>
            <span className="text-[#7A7A7A] text-center xl:text-[1.2rem] text-[1rem] lg:w-[70%] md:w-[85%] w-[100%] mx-auto">
              Stay updated with the latest developments and initiatives from
              Rawalpindi Development Authority
            </span>
          </div>

          {isFetching || isLoading ? (
            <BlogCardLoader items={4} />
          ) : (
            data &&
            data?.blogs?.length !== 0 && (
              <div className=" grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1  gap-8 self-stretch justify-items-center">
                {data?.blogs?.map((blog, i) => (
                  <NavLink
                    to={`/blog/${blog?._id}`}
                    key={i}
                    className={`p-4 relative flex flex-col group cursor-pointer gap-2 rounded-2xl shadow hover:bg-[#00643b] hover:text-white bg-[#F6F6F6] text-black
                   `}
                  >
                    <span
                      className={`absolute bg-[#00643b] text-white text-[.9rem]  py-1 px-4 top-6 left-6 rounded-lg`}
                    >
                      Blog
                    </span>
                    <img
                      src={blog?.coverImage?.imageUrl}
                      className="rounded-2xl"
                      alt=""
                    />
                    <h1 className="text-[1.2rem] font-medium">{blog.title}</h1>
                  </NavLink>
                ))}
              </div>
            )
          )}

          {(data?.blogs?.length === 0 || error) && (
            <div className=" text-center w-full lg:text-[2rem] md:text-[1.5rem] text-[1.1rem] font-semibold text-[#000000]">
              No Latest news Found
            </div>
          )}
          {(data?.blogs?.length > 0 || !error) && (
            <NavLink
              to={"/blogs"}
              className="w-max text-white py-2 px-5  bg-[#00643b] font-semibold text-[1rem] rounded-xl"
            >
              See more
            </NavLink>
          )}
        </div>
      )}
    </>
  );
};

export default NewsSlider;

{
  /* <Swiper
          modules={[Navigation, Autoplay, FreeMode, Pagination]}
          navigation={false}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            stopOnLastSlide: false,
          }}
          breakpoints={{
            320: {
              slidesPerView: 1, // Extra small (XS)
            },
            425: {
              slidesPerView: 1.3, // Small phones
            },
            580: {
              slidesPerView: 1.55, // Small phones
            },
            640: {
              slidesPerView: 1.9, // Tailwind sm
            },
            768: {
              slidesPerView: 2.2, // Tailwind md
            },
            1024: {
              slidesPerView: 2.7, // Tailwind lg
            },
            1280: {
              slidesPerView: 3, // Tailwind xl
            },
            1536: {
              slidesPerView: 4,
            },
          }}
          // pagination={{ clickable: true }}
          loop={true}
        > */
}
{
  /* </Swiper> */
}
